import { DIFFICULTY_BANDS } from './bands';

const labelClassName =
  'font-open-sans text-[11px] font-semibold uppercase tracking-[0.08em] text-neutral-500';

// Easier on the left through to harder on the right, using the same
// backgrounds as the cells so the legend matches the grid.
const LEGEND_ORDER = [
  'very-easy',
  'easy',
  'moderate',
  'hard',
  'very-hard'
] as const;

export const Legend = () => (
  <div
    className="flex items-center gap-3.5"
    data-testid="fixture-analyser-legend"
  >
    <span className={labelClassName}>Easier</span>
    <div className="flex gap-[3px]">
      {LEGEND_ORDER.map((variant) => (
        <span
          key={variant}
          className="h-2 w-[26px] rounded-sm"
          style={{ backgroundColor: DIFFICULTY_BANDS[variant].background }}
        />
      ))}
    </div>
    <span className={labelClassName}>Harder</span>
  </div>
);
